import { RouteGuardShape } from "@core/types/route.type";
import HomePage from "./pages/home";
import { Role } from "./constants";
import ExamPage from "./pages/exam";
import ExamResultPage from "./pages/exam-result/exam-result.page";

const router: RouteGuardShape[] = [
  {
    path: "/",
    component: HomePage,
    config: {
      roles: [Role.ADMIN, Role.MEMBER],
      redirect: "/login"
    }
  },
  {
    path: "/home",
    component: HomePage,
    // config: {
    //   roles: [Role.ADMIN, Role.MEMBER],
    //   redirect: "/login"
    // }
  },
  {
    path: "/exam/:id",
    component: ExamPage,
    config: {
      roles: [Role.ADMIN, Role.MEMBER],
      redirect: "/login"
    }
  },
  {
    path: "/exam-result",
    component: ExamResultPage,
    config: {
      roles: [Role.ADMIN, Role.MEMBER],
      redirect: "/login"
    }
  }
];

export default router;
